import { useQuery } from '@apollo/client';

import {
  MasterDirectoryLocationsBySkillDocument,
  MasterDirectoryLocationsBySkillQuery,
} from '@xing-com/crate-master-directory-graphql';

type LocationsBySkillParams = {
  skill: string;
};

export const useGetLocationsBySkill = ({
  skill,
}: LocationsBySkillParams): {
  loading: boolean;
  data: MasterDirectoryLocationsBySkillQuery['jobsLinkBoxSkillTopLocations'];
} => {
  const document = MasterDirectoryLocationsBySkillDocument;
  const { loading, data } = useQuery(document, {
    variables: {
      skill,
    },
  });

  const _data = data?.jobsLinkBoxSkillTopLocations || [];

  return { loading, data: _data };
};
